<template>
  <template v-if="isEnabled">
    <dpc-input-tab-list-item :value="id" class="tab-list__item">{{
      label
    }}</dpc-input-tab-list-item>
    <portal v-if="currentTab === id" :to="tabListContentTargetName">
      <slot />
    </portal>
  </template>

  <template v-else>
    <slot />
  </template>
</template>

<script>
import { inject } from 'vue';

export default {
  props: {
    id: {
      type: String,
      default() {
        return `tab-list-item-${this.label}`;
      },
    },
    label: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const tabListId = inject('tabList/id');
    const currentTab = inject('tabList/currentTab');
    const tabListContentTargetName = inject('tabList/contentTargetName');
    const isEnabled = inject('tabList/isEnabled');

    return {
      tabListId,
      currentTab,
      tabListContentTargetName,
      isEnabled,
    };
  },
};
</script>
